import { List, Datagrid, TextInput, EmailField, useRecordContext, EditButton } from 'react-admin';
import { TextField} from 'react-admin';

const StatusField = ({ source }: any) => {
    const record = useRecordContext();
    return (<span style={{ background: record[source] == 1 ? '#158315' : '#df1b1b', width: '10px', height: '10px', borderRadius: '50%', float: 'left'  }}>&nbsp;</span>);
};

const adminFilters = [
    <TextInput label="Title" source="title" defaultValue="" />,
];

export const ApiList = () => (
    <List filters={adminFilters}>
        <Datagrid rowClick="show">
            <TextField source="title" />
            <TextField label="Endpoint" source="url" />
            <TextField label="Interval Time (Min)" source="interval_time" />
            <StatusField source="status" />
            <TextField source="created_at" />
            <EditButton />
        </Datagrid>
    </List>
);